import { defineMessages } from 'react-intl';

const messages = defineMessages({
  formTitle: {
    id: 'Data da requisição',
    defaultMessage: 'Data da requisição',
  },
  text: {
    id: 'Texto',
    defaultMessage: 'Texto',
  },
  longDate: {
    id: 'Incluir hora e minutos',
    defaultMessage: 'Incluir hora e minutos',
  },
});

export const requestDateSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.formTitle),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['text', 'long'],
      },
    ],
    properties: {
      text: {
        title: props.intl.formatMessage(messages.formTitle),
        default: 'Dados atualizados em: ',
      },
      long: {
        title: props.intl.formatMessage(messages.longDate),
        type: 'boolean',
        default: false,
      },
    },
    required: ['text'],
  };
};
